import { createContext } from 'react'

// App-wide contexts

export const ConfirmContext = createContext()
